<template>
  <div class="open-app-display">
    <sub-menu :activeNum="0"></sub-menu>
    <div class="business-title">
      <button class="addapp"  @click="openCreatePublic" v-if="loaded && apps.length > 0">
        <span class="icon-plus"></span>
        <span class="text">申请公有云服务</span>
      </button>
    </div>
    <div v-if="loaded && apps.length > 0">
      <div class="public-list" v-for="(softItem, softIndex) in apps" :key="softIndex">
        <div class="header">
          <div class="border"></div>
          <div class="thead-title">
            <div class="app-title">
              <span>{{softItem.name}}</span>
            </div>
            <div class="check" :class="{
              'checking': softItem.status == AppStatusKey.FORMAL_VERIFYING,
              'check-success': softItem.status == AppStatusKey.FORMAL_VERIFY_SUCCESS,
              'check-fail': softItem.status == AppStatusKey.FORMAL_VERIFY_FAIL || softItem.status == AppStatusKey.STOP}"
            >
              <!-- <span class="app-apply-time">{{softItem.submittime}}</span> -->
              <div class="status-item">{{DisplayMapper.APP_APPLY_STATUS[softItem.status]}}</div>
              <div class="app-status-item-text" v-if="softItem.status == AppStatusKey.FORMAL_VERIFY_FAIL">
                <span class="status-item-label">审核失败原因：</span>
                <span class="status-item-reason">{{softItem.reason}}</span>
              </div>
              <div class="app-status-item-text disable" v-if="softItem.status == AppStatusKey.STOP">
                <span class="status-item-label-disable">禁用原因：</span>
                <span class="status-item-reason-disable">{{softItem.disablereason}}</span>
              </div>
            </div>
          </div>
          <div class="btn-group" v-if="softItem.status != AppStatusKey.FORMAL_VERIFYING">
            <button class="app-del-btn" @click="handleDeleteApp(softItem)">删除</button>
          </div>
        </div>
        <div class="app-info" :class="{'app-view-fail': softItem.status == AppStatusKey.FORMAL_VERIFY_FAIL || softItem.status == AppStatusKey.STOP}">
          <div class="app-info-container">
            <div class="app-label app-label-left">申请时间:</div>
            <div class="app-value app-value-left">{{softItem.optime}}</div>
          </div>
          <div class="app-info-container" v-if="softItem.status == AppStatusKey.FORMAL_VERIFY_SUCCESS">
            <div class="app-label app-label-left">AppID:</div>
            <div class="app-value key-color app-value-right">{{softItem.appid}}</div>
          </div>
          <div class="app-info-container">
            <div class="app-label app-label-left">应用平台:</div>
            <div class="app-value app-value-left" v-if="softItem.status == AppStatusKey.FORMAL_VERIFY_SUCCESS">{{applyStatusHelper.app.calculateAppPlatform(softItem.platform)}}</div>
            <div class="app-value app-value-right" v-else>{{applyStatusHelper.app.calculateAppPlatform(softItem.platform)}}</div>
          </div>
          <div class="app-info-container" v-if="softItem.status == AppStatusKey.FORMAL_VERIFY_SUCCESS">
            <div class="app-label app-label-left">SecretID:</div>
            <div class="app-value key-color app-value-right">{{softItem.secretid}}</div>
          </div>
          <div class="app-info-container">
            <div class="app-label app-label-left">应用类型:</div>
            <div class="app-value app-value-left">{{DisplayMapper.USAGE_TYPE[softItem.softtype]}}</div>
          </div>
          <div class="app-info-container" v-if="softItem.status == AppStatusKey.FORMAL_VERIFY_SUCCESS">
            <div class="app-label app-label-left">SecretKey:</div>
            <div class="app-value key-color app-value-right">{{softItem.secretkey}}</div>
          </div>
          <div class="app-info-container" v-if="softItem.address != ''">
            <div class="app-label app-label-left">应用地址:</div>
            <div class="app-value app-value-right" :class="{'app-value-left': softItem.status == AppStatusKey.FORMAL_VERIFY_SUCCES}">{{softItem.address}}</div>
          </div>
          <div class="app-info-row">
            <div class="app-info-container">
              <div class="app-label app-label-left">应用简介:</div>
              <div class="app-value desc">
                <description-folder :content="softItem.scene" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="business-empty" v-if="loaded && apps.length === 0">
      <div class="business-empty-icon"></div>
      <div class="business-empty-text">
        您还没有应用<br>
        单击“申请公有云服务”按钮，申请优图公有云服务
      </div>
      <button class="addapp" @click="$router.transfer(RouteKey.OPEN_APP_CREATOR)">
        <span class="icon-plus"></span>
        <span class="text">申请公有云服务</span>
      </button>
    </div>
  </div>
</template>
<script>
import AppDisplayer from './js/AppDisplayer';
export default AppDisplayer;
</script>
<style lang='less'>
@import "../../../../../styles/btn.less";
@import "./css/common-display.less";
@import "./css/app-displayer.less";
</style>



// WEBPACK FOOTER //
// src/components/open/panels/application/panels/PublicCloudDisplay.vue